import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserPlus, UserCheck, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const FavoriteMaestroButton = ({ businessId, name }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [fav, setFav] = useState(false);
  const [busy, setBusy] = useState(false);
  const isCustomer = user?.role === "customer";

  useEffect(() => {
    if (!isCustomer) return;
    api.get("/favorite-maestros/ids").then(({ data }) => setFav(data.includes(businessId))).catch(() => {});
  }, [isCustomer, businessId]);

  if ((user && !isCustomer) || (user && user.owned_business_id === businessId)) return null;

  const toggle = async () => {
    if (!user) { toast.info("Inicia sesión como alumno para seguir a este Maestro"); navigate("/login"); return; }
    setBusy(true);
    try {
      if (fav) { await api.delete(`/favorite-maestros/${businessId}`); toast.success(`Dejaste de seguir a ${name}`); }
      else { await api.post("/favorite-maestros", { business_id: businessId }); toast.success(`Ahora sigues a ${name}: verás sus sesiones en «Mis Maestros»`); }
      setFav(!fav);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Button variant={fav ? "default" : "outline"} size="sm" onClick={toggle} disabled={busy}
      className="gap-1.5 rounded-full transition-colors" data-testid="favorite-maestro-btn" aria-pressed={fav}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : fav ? <UserCheck className="w-4 h-4" /> : <UserPlus className="w-4 h-4" />}
      {fav ? "Siguiendo" : "Seguir"}
    </Button>
  );
};
